<template>
<div>
  <ErrorPlankk />
  <PrimaryHeader />
  <b-container fluid :class="$style.container">
    <b-row class="parent-row">
      <b-col :class="$style.bodyContainer">
        <slot />
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import PrimaryHeader from 'PrimaryHeader/PrimaryHeader.vue';
import GroceryList from 'GroceryList/GroceryList.vue';
import ErrorPlankk from 'Modals/ErrorPlankk';
import { breakpointsMixin } from 'breakpointsMixin';
import { authApiMethods, authComputed } from '@state/helpers';

export default {
  mixins: [breakpointsMixin],
  components: {
    ErrorPlankk,
    GroceryList,
    PrimaryHeader,
  },
  data() {
    return {
      isEmbed: false,
    };
  },
};
</script>

<style lang="scss" module>
@import 'theme.scss';

.container {
  max-width: 100vw;
  min-width: 100vw;
}

.bodyContainer {
  height: 100vh;
  overflow: scroll;
  padding: 0;
  width: calc(100vw - 26rem);
}
</style>
